import {
    DATA_POINTS_1,
    DATA_POINTS_2,
    DATA_POINTS_3,
    DATA_POINTS_4
} from '../watchlists';

const DEFAULT = {
    STOCK_SYMBOL: '0P0000034X',
    FUND_SYMBOL: 'FOUSA00BKS',
    COLUMN_SET_BEHAVIOUR: 'merge'
};

const releaseKeyBankLive = true; // control release keybank RTCOMP-17647 to live

let CUSTOM_DATA_POINTS = [],
    KPB_COLUMNS_SETS = [],
    CUSTOM_COLUMN_SETS = [],
    KPB_CUSTOM_GROUP_DATA_POINTS = [];

if (releaseKeyBankLive) {
    CUSTOM_DATA_POINTS = [
        {
            id: 'keyClassification1',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Key Classification 1'
        },
        {
            id: 'keyClassification2',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Key Classification 2'
        },
        {
            id: 'keyClassification3',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Key Classification 3'
        },
        {
            id: 'key2SMA',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Key2SMA'
        },
        {
            id: 'keyRegion',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Region'
        },
        {
            id: 'keyMarketCap',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Market Cap.'
        },
        {
            id: 'keyAssetSuitability',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Asset Suitability'
        },
        {
            id: 'minInitialInvestment',
            align: 'right',
            width: 80,
            dataType: 'number',
            category: 'proprietaryData',
            label: 'Min. Initial Investment'
        },
        {
            id: 'equityAllWeatherScore',
            align: 'right',
            dataType: 'number',
            category: 'proprietaryData',
            label: 'Equity All-Weather Score'
        },
        {
            id: 'kpbESGScore',
            align: 'right',
            dataType: 'number',
            category: 'proprietaryData',
            label: 'KPB ESG Score'
        },
        {
            id: 'kpbQualityScore',
            align: 'right',
            dataType: 'number',
            category: 'proprietaryData',
            label: 'KPB Quality Score'
        },
        {
            id: 'capGainsEstDate',
            align: 'right',
            dataType: 'date',
            width: 80,
            category: 'proprietaryData',
            label: 'Cap. Gains Est Date'
        },
        {
            id: 'estShortTermCap',
            align: 'right',
            dataType: 'number',
            width: 80,
            category: 'proprietaryData',
            label: 'Est. Short-term Cap.'
        },
        {
            id: 'estLongTermCap',
            align: 'right',
            dataType: 'number',
            width: 80,
            category: 'proprietaryData',
            label: 'Est. Long-term Cap.'
        },
        {
            id: 'estTotalCapGain',
            align: 'right',
            width: 80,
            dataType: 'number',
            category: 'proprietaryData',
            label: 'Est. Total Cap Gain'
        },
        {
            id: 'capGainsSellByDate',
            align: 'right',
            dataType: 'date',
            width: 80,
            category: 'proprietaryData',
            label: 'Cap. Gains Sell By Date'
        },
        {
            id: 'netExpenseRatio',
            align: 'right',
            dataType: 'number',
            category: 'proprietaryData',
            label: 'Net Expense Ratio'
        },
        {
            id: 'taxLossSub',
            align: 'left',
            dataType: 'string',
            category: 'proprietaryData',
            label: 'Tax Loss Sub.'
        },
        {
            id: 'addedDate',
            align: 'right',
            dataType: 'date',
            category: 'proprietaryData',
            label: 'Date Added'
        }
    ];

    KPB_COLUMNS_SETS = [
        {
            id: 'kpbEquity',
            dataPoints: [
                'name',
                'symbol',
                'lastPrice',
                'chg',
                'chg%',
                'week52HighPrice',
                'week52LowPrice',
                'dividendYieldCurrent',
                'forwardPERatio',
                'equityAllWeatherScore',
                'kpbQualityScore',
                'kpbESGScore',
                'turnover',
                'taxLossSub',
                'netExpenseRatio',
                'minInitialInvestment',
                'estTotalCapGain',
                'capGainsSellByDate'
            ]
        },
        {
            id: 'kpbFixedIncome',
            dataPoints: [
                'name',
                'symbol',
                'secYield',
                'ttMYield',
                'effectiveMaturity',
                'effectiveDuration',
                'creditQualityAaa',
                'creditQualityAa',
                'creditQualityA',
                'creditQualityBbb',
                'creditQualityBb',
                'creditQualityB',
                'creditQualityNotRated',
                'taxLossSub',
                'netExpenseRatio',
                'minInitialInvestment',
                'estTotalCapGain',
                'capGainsSellByDate'
            ]
        }
    ];

    CUSTOM_COLUMN_SETS = [
        {
            id: 'basic',
            dataPoints: [
                'name',
                'symbol',
                'lastPrice',
                'chg',
                'chg%',
                'highPrice',
                'lowPrice',
                'tradeDate',
                'tradeTime'
            ]
        },
        ...KPB_COLUMNS_SETS
    ];

    KPB_CUSTOM_GROUP_DATA_POINTS = [
        {
            id: 'keyClassificationDefault',
            label: 'Key Classification',
            points: [
                'keyClassification1',
                'keyClassification2',
                'keyClassification3'
            ]
        },
        {
            id: 'keyClassificationRegion1',
            label: 'Key Classification - Region 1',
            points: ['keyClassification1', 'region', 'keyMarketCap']
        },
        {
            id: 'keyClassificationRegion2',
            label: 'Key Classification - Region 2',
            points: ['keyClassification1', 'region', 'keyClassification3']
        }
    ];
}

const DEFAULT_CUSTOM_GROUP = [
    {
        id: 'groupName',
        label: 'Custom Group',
        points: ['groupName']
    }
];
const components = [
    {
        componentName: 'markets-components-svgchart',
        componentType: 'markets-components-svgchart',
        componentState: {
            mainTicker: DEFAULT.STOCK_SYMBOL
        }
    },
    {
        componentName: 'mwc-markets-commodity',
        componentType: 'mwc-markets-commodity',
        componentState: {}
    },
    {
        componentName: 'mwc-markets-forex',
        componentType: 'mwc-markets-forex',
        componentState: {}
    },
    {
        componentName: 'mwc-markets-gla',
        componentType: 'mwc-markets-gla',
        componentState: {
            gridHover: {
                menu: []
            }
        }
    },
    // {
    //     componentName: 'mwc-markets-gmb',
    //     componentType: 'mwc-markets-gmb',
    //     componentState: {
    //         salBundleHost: 'lib/'
    //     }
    // },
    {
        componentName: 'mwc-markets-sector-heatmap',
        componentType: 'mwc-markets-sector-heatmap',
        componentState: {
            showOneDayAsIntraday: true
        }
    },
    {
        componentName: 'mwc-markets-watchlist-morningstar-sector',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            showExcelRTD: true,
            gridHover: {
                menu: []
            },
            defaultDataPoints: DATA_POINTS_2,
            columnSets: CUSTOM_COLUMN_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: KPB_CUSTOM_GROUP_DATA_POINTS
        },
        title: 'Morningstar Sector Watchlist',
        groupName: 'Markets',
        showAutocomplete: false,
        showSettingIcon: true,
        showExportIcon: true,
        showSymbol: false,
        desc:
            'Morningstar Sector Watchlist allows you to access and analyze intraday and historical exchange market data for Morningstar Sectors.'
    },
    {
        componentName: 'mwc-markets-options',
        componentType: 'mwc-markets-options',
        componentState: {
            symbol: DEFAULT.STOCK_SYMBOL
        }
    },
    {
        componentName: 'mwc-markets-watchlist-pre-market-futures',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            title: 'Pre-Market Futures',
            showExcelRTD: true,
            gridHover: {
                menu: []
            },
            defaultDataPoints: DATA_POINTS_2,
            columnType: 'basic',
            columnSets: CUSTOM_COLUMN_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: KPB_CUSTOM_GROUP_DATA_POINTS,
            labels: {
                en: {
                    name: 'Market',
                    lastPrice: 'Cur Future'
                },
                fr: {
                    name: 'Marché',
                    lastPrice: 'Courant Futur'
                }
            }
        },
        isClosable: true,
        title: 'Pre-Market Futures',
        showExportIcon: false,
        groupName: 'Markets',
        showSymbol: false,
        showSettingIcon: false,
        /* eslint-disable */
        desc:
            "Pre-Market Futures component provides an indication (but not a prediction) of how the stock market may open when trading commences. Pre-market futures are stock index futures evaluated prior to the start of the day's stock trading. Futures and stocks trade separately, but the price of the index relative to the value of index futures gives a strong hint regarding stock market early action."
        /* eslint-disable */
    },
    {
        componentName: 'mwc-markets-quote',
        componentType: 'mwc-markets-quote',
        componentState: {
            symbol: DEFAULT.STOCK_SYMBOL
        }
    },
    {
        componentName: 'markets-components-minichart',
        componentType: 'markets-components-minichart',
        componentState: {
            frequency: '5',
            interval: '1D',
            mainTicker: DEFAULT.STOCK_SYMBOL
        }
    },
    {
        componentName: 'mwc-markets-watchlist-morningstar-government',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            showExcelRTD: true,
            gridHover: {
                menu: []
            },
            defaultDataPoints: DATA_POINTS_2,
            columnSets: CUSTOM_COLUMN_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: KPB_CUSTOM_GROUP_DATA_POINTS
        },
        title: 'U.S. Government Bond Watchlist',
        groupName: 'Markets',
        showAutocomplete: false,
        showSettingIcon: true,
        showExportIcon: true,
        showSymbol: false,
        desc:
            'U.S. Government Bond Watchlist allows you to access and analyze intraday and historical exchange market data for various maturities across the U.S. Government bond market.'
    },
    {
        componentName: 'mwc-markets-barometer',
        componentType: 'mwc-markets-barometer'
    },
    {
        componentName: 'mwc-markets-treasury',
        componentType: 'mwc-markets-treasury',
        componentState: {}
    },
    {
        componentName: 'mwc-markets-watchlist',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'custom',
        componentState: {
            removable: true,
            defaultDataPoints: DATA_POINTS_1,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: KPB_CUSTOM_GROUP_DATA_POINTS,
            showExcelRTD: true,
            gridHover: {
                removable: true,
                menu: []
            },
            symbol: ''
        },
        isClosable: true,
        title: 'Watchlist',
        groupName: 'Markets',
        showSymbol: false,
        showSettingIcon: true,
        showExportIcon: true,
        showImportIcon: true,
        showAutocomplete: true,
        desc:
            'Watchlist allows user to access and analyze intraday and historical exchange data for their investments.'
    },
    {
        componentName: 'mwc-markets-news-investment',
        componentType: 'mwc-markets-news',
        componentState: {
            newsType: 'investment',
            newsTypeOptions: '',
            symbol: DEFAULT.STOCK_SYMBOL,
            usMarketsSourceCode:
                'DJNMNDJMW,AWRAWR,BWIPREMBWIPREM,GLBNEWSDOTCOM,NASDAQNEWSNASDAQRNS,PRNPREMPRNPREM,ZACKSZIRGENERIC'
        },
        title: 'Investment News',
        showSymbol: true,
        showAutocomplete: true,
        groupName: 'News',
        desc:
            'Investment News component allows you to monitor and read third-party news on the investment in focus. The news feed is updated automatically, and you can filter by specific providers.'
    },
    {
        componentName: 'mwc-markets-news-daily-briefings',
        componentType: 'mwc-markets-news',
        componentState: {
            newsTypeOptions: '',
            newsType: 'dailyBriefings'
        },
        title: 'Daily Briefings',
        showSymbol: false,
        showSettingIcon: false,
        groupName: 'News',
        desc:
            'Daily briefings news component allows you to get daily briefings from Dowjones.'
    },
    {
        componentName: 'mwc-markets-news-us-markets',
        componentType: 'mwc-markets-news',
        componentState: {
            newsTypeOptions: 'usMarkets,mostViewed',
            showProviderSetting: true,
            usMarketsSourceCode:
                'DJNMNDJMW,AWRAWR,BWIPREMBWIPREM,GLBNEWSDOTCOM,NASDAQNEWSNASDAQRNS,PRNPREMPRNPREM,ZACKSZIRGENERIC',
            newsType: 'usMarkets',
            symbol: DEFAULT.STOCK_SYMBOL
        },
        title: 'U.S. Market News',
        showSymbol: false,
        groupName: 'News',
        desc:
            'U.S. Market News component allows you to monitor and read intraday news on the U.S. Markets.'
    },
    // {
    //     componentName: 'mwc-markets-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         layout: 'list',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Morningstar Report',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report',
    //     /* eslint-disable */
    //     desc:
    //         "Morningstar Stock Report Providing a curated composition of Morningstar's research, data, and visualizations to help investors decide whether it is a good time to buy or sell a stock. " +
    //         "Morningstar's impartial and rigorous research is performed by a team of 97 analysts globally. Over 1,400 companies are covered by an analyst. The remainder of the stock universe is covered by a quantitative model that estimates the value a Morningstar® analyst would likely assign to the company.<br/><br/> " +
    //         "Morningstar Fund Report helps investors assess the fund and its manager using Morningstar's own research, data, and visualizations. " +
    //         "Morningstar's impartial and rigorous research is performed by a team of over 100 analysts. Our analysts provide qualitative research for 2,000+ mutual funds and 300+ exchange-traded funds in the US alone. " +
    //         "This report is only available in a fund's base currency.<br/><br/>" +
    //         "Our Index Report provides an easy one-page view of the key characteristics of a range of global and local indices. This report covers both Morningstar and 3rd party indices (subject to license agreements)."
    //     /* eslint-disable */
    // },
    // {
    //     componentName: 'mwc-markets-profile-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'profile',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Company Profile',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Equity',
    //     desc:
    //         'Company Profile component containing corporate office information and general business description of the company.'
    // },
    // {
    //     componentName: 'mwc-markets-dividends-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'dividends',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Corporate Actions',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showSettingIcon: false,
    //     showPrintIcon: true,
    //     groupName: 'Report - Equity',
    //     desc:
    //         'Corporate Actions component provides the financial well-being and shareholder value in terms of dollar amount each share receives and percent of the current market.'
    // },
    // {
    //     componentName: 'mwc-markets-executive-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'executive',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Executive Team',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Equity',
    //     desc:
    //         'Executives Team component provides a detailed view of company executive and compensation information.'
    // },
    // {
    //     componentName: 'mwc-markets-financials-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'financials',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Fundamentals',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Equity',
    //     desc:
    //         "Fundamentals Component provides detail view of company's financial statements."
    // },
    // {
    //     componentName: 'mwc-markets-operating-performance',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'performance',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Operating Performance',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Equity',
    //     desc:
    //         "Operating Performance component uses charts and ratios to depict how efficiently a company is using its resources to generate sales and increase shareholder value. Providing historical trends and movement of holding along with Morningstar proprietary data. Used to analyze effectiveness of companies' operations."
    // },
    // {
    //     componentName: 'mwc-markets-ownership-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'ownership',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Ownership',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Equity',
    //     desc:
    //         'Ownership component contains percentages of common shares owned by funds and current buy/sell activity, it provides a detailed view of key funds or institutions that own a stock in its portfolio.'
    // },
    // {
    //     componentName: 'mwc-markets-trailingReturns-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'trailingReturns',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Trailing Returns',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Equity',
    //     desc:
    //         'Trailing Returns component provides historical return of a stock with side-by-side comparison to the respective benchmark and sector. It broadly gives user an idea about whether the stock has created or depleted wealth over a specific time period.'
    // },
    // {
    //     componentName: 'mwc-markets-valuation-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         activeModule: 'valuation',
    //         type: 'basic',
    //         symbol: DEFAULT.STOCK_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Valuation',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Equity',
    //     /* eslint-disable */
    //     desc:
    //         "Valuation Component contains ratios and information used to determine the equity's value based on its earnings outlook, market value, and other financial metrics."
    //     /* eslint-disable */
    // },
    // {
    //     componentName: 'mwc-markets-fee-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         autoHeight: true,
    //         activeModule: 'price',
    //         showAutocomplete: true,
    //         type: 'basic',
    //         symbol: DEFAULT.FUND_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Fee',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Fund & ETF',
    //     desc:
    //         'Fee component is Fund and ETF specific that provides a detailed view of the fees associated with the investments.'
    // },
    // {
    //     componentName: 'mwc-markets-firm-profile-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         autoHeight: true,
    //         activeModule: 'parent',
    //         showAutocomplete: true,
    //         type: 'basic',
    //         symbol: DEFAULT.FUND_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Firm Profile',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Fund & ETF',
    //     desc:
    //         'Firm Profile component is Fund and ETF specific that provides a detailed view of fund flows and fund family details for the investment firm.'
    // },
    // {
    //     componentName: 'mwc-markets-fund-management-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         autoHeight: true,
    //         activeModule: 'people',
    //         showAutocomplete: true,
    //         type: 'basic',
    //         symbol: DEFAULT.FUND_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Fund Management',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Fund & ETF',
    //     desc:
    //         'Fund Management component provides a full view of the management team and their tenure with the investment firm. Detail view is available to show the total assets and list of funds managed by each manager.'
    // },
    // {
    //     componentName: 'mwc-markets-performance-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         autoHeight: true,
    //         activeModule: 'performance',
    //         showAutocomplete: true,
    //         type: 'basic',
    //         symbol: DEFAULT.FUND_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Performance',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Fund & ETF',
    //     desc:
    //         'Performance component provides historical return of a security with side-by-side comparison to the respective benchmark and peer group.'
    // },
    // {
    //     componentName: 'mwc-markets-portfolio',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         autoHeight: true,
    //         activeModule: 'portfolio',
    //         showAutocomplete: true,
    //         type: 'basic',
    //         symbol: DEFAULT.FUND_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Portfolio',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Fund & ETF',
    //     desc:
    //         'Portfolio component is Fund and ETF specific that provides a full view of portfolio details including Asset Allocation, Stock Style, Market Exposure, Financial Metrics, Sustainability & Carbon Metrics and Top investment holdings.'
    // },
    // {
    //     componentName: 'mwc-markets-risk-report',
    //     componentType: 'mwc-markets-report',
    //     componentState: {
    //         showNav: false,
    //         autoHeight: true,
    //         activeModule: 'risk',
    //         showAutocomplete: true,
    //         type: 'basic',
    //         symbol: DEFAULT.FUND_SYMBOL,
    //         salBundleHost: 'lib/'
    //     },
    //     title: 'Risk',
    //     showSymbol: true,
    //     showAutocomplete: true,
    //     showPrintIcon: true,
    //     showSettingIcon: false,
    //     groupName: 'Report - Fund & ETF',
    //     /* eslint-disable */
    //     desc:
    //         "Risk component is Fund and ETF specific that provides risk/return analysis based on assessment of variations of the fund's monthly returns in comparison to similar funds. The greater the variation, the larger the risk score. Funds with less than three years of performance history are not rated."
    //     /* eslint-disable */
    // },
    {
        componentName: 'mwc-markets-watchlist-real-assets',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_3,
            defaultDataPoints: DATA_POINTS_3,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'Real Assets Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-core-equity',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_4,
            defaultDataPoints: DATA_POINTS_4,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'Core Equity Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-high-dividend',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_4,
            defaultDataPoints: DATA_POINTS_4,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'High Dividend Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-sea-equity',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_4,
            defaultDataPoints: DATA_POINTS_4,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'SEA Equity Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-us-equity',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_3,
            defaultDataPoints: DATA_POINTS_3,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'U.S. Equity Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-intl-equity',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_3,
            defaultDataPoints: DATA_POINTS_3,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'Intl Equity Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-fixed-income',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_3,
            defaultDataPoints: DATA_POINTS_3,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'Fixed Income Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-alternatives',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'custom',
            gridHover: {
                menu: []
            },
            dataPoints: DATA_POINTS_3,
            defaultDataPoints: DATA_POINTS_3,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'Alternatives Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    },
    {
        componentName: 'mwc-markets-watchlist-kpb-market',
        componentType: 'mwc-markets-watchlist',
        watchlistType: 'static',
        componentState: {
            columnType: 'basic',
            gridHover: {
                menu: []
            },
            defaultDataPoints: DATA_POINTS_1,
            columnSets: KPB_COLUMNS_SETS,
            columnSetsBehaviour: DEFAULT.COLUMN_SET_BEHAVIOUR,
            customColumns: CUSTOM_DATA_POINTS,
            customGroupDataPoints: [
                ...KPB_CUSTOM_GROUP_DATA_POINTS,
                ...DEFAULT_CUSTOM_GROUP
            ],
            groupKey: 'groupName',
            enableGroup: true
        },
        title: 'KPB Market Indexes Watchlist',
        showSettingIcon: true,
        showExportIcon: true,
        groupName: 'Markets',
        showSymbol: false,
        showAutocomplete: false,
        desc: ''
    }
];

export default components;
